var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { Component } from "react";
import { Col, Row } from "react-bootstrap";
import id from "@irati/utils/id";
import rewardWalletTracking from "@irati-tracking/wallet/rewardWallet";
import Container from "../styled/Container";
import Intro from "../../components/Reward/Intro";
import HeaderBalance from "../../components/Reward/HeaderBalance";
import Transactions from "../../components/Reward/Transactions";
var RewardWallet = /** @class */ (function (_super) {
    __extends(RewardWallet, _super);
    function RewardWallet() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    RewardWallet.prototype.componentDidMount = function () {
        rewardWalletTracking.viewRewardWallet();
    };
    RewardWallet.prototype.render = function () {
        var idNamespace = id("reward-wallet", this.props, { force: true });
        return (React.createElement(Container, null,
            React.createElement(Row, null,
                React.createElement(Col, { md: 6, lg: 5 },
                    React.createElement(Intro, null)),
                React.createElement(Col, { md: 6, lg: 7 },
                    React.createElement(HeaderBalance, { id: idNamespace }))),
            React.createElement(Row, null,
                React.createElement(Col, { md: 12 },
                    React.createElement(Transactions, { id: id })))));
    };
    return RewardWallet;
}(Component));
export default RewardWallet;
